import React, { Component } from 'react'
import Page from '../components/Page'
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay'
import SubscribeForm from '../partials/SubscribeForm'
import InjectedCheckoutForm from '../partials/PaymentForm'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import subscriptionApi, {SubscriptionCreateRequest, PendingPaymentRequest } from '../apis/subscriptionApi'
import alertService from '../services/alert.service'
import { set } from 'store'

interface Props extends RouteComponentProps {}

interface State {
  subscriptionStepOn : boolean
  paymentStepOn : boolean
  stripe: Stripe | null
  fullName: string
  role: string
  username: string
  email: string
  phone: string
  organizationName: string
  timezone: string
  address: string
  city: string
  state: string
  zip: string
  selectedSubscriptionId : number
  amountSelected : number
  clientSecret: string
  subId : number
  ephemeralKey: string
  customer: string
  isLoading: boolean
}

const stripePromise = loadStripe('pk_live_51OdyiFB1SCFKDF5MhFPqWS2CJPcpxr7vWXUyXrumw8JZ3QYBuBeZdp8jBOCcNQ6Dpvzk0ucZrRbP573DbBh85dJX00tLiMBHM6');

export default class Subscribe extends Component<Props, State> {

  initialState: State = {
    subscriptionStepOn: true,
    paymentStepOn: false,
    stripe: null,
    fullName: '',
    role: '',
    username: '',
    email: '',
    phone: '',
    organizationName: '',
    timezone: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    selectedSubscriptionId : 0,
    amountSelected : 0,
    clientSecret: '',
    subId: 0,
    ephemeralKey: '',
    customer: '',
    isLoading: false
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.onSubscribe = this.onSubscribe.bind(this)
    this.handleCreateError = this.handleCreateError.bind(this)
    this.handleMissingField = this.handleMissingField.bind(this)
    this.handleMissingFieldWithErr = this.handleMissingFieldWithErr.bind(this)
    
  }

  componentDidMount() {
      stripePromise.then(stripe => {
          this.setState({ stripe });
      });
  }

  handleCreateError(error: string) {
    alertService.error('There was an error with your request. Please review your data and try again.')
    this.setState({isLoading:false})
  }

  handleMissingField(field: string) {
    alertService.warning('The '+field+' is invalid. Please review it, and try again')
    this.setState({isLoading:false})
  }

  handleMissingFieldWithErr(msg: string) {
    alertService.warning(msg)
    this.setState({isLoading:false})
  }

  onSubscribe(
    fullName: string,
    role: string,
    username: string,
    email: string,
    phone: string,
    organizationName: string,
    timezone: string,
    address: string,
    city: string,
    state: string,
    zip: string,
    amountSelected: number,
    selectedSubscriptionId : number
  ) {
    this.setState({isLoading: true})
    const payloadPendingPayment: PendingPaymentRequest = {
      amount: amountSelected,
      email: email,
      name: fullName,
      packageId: selectedSubscriptionId,
      subId: 0
    }

    const payload: SubscriptionCreateRequest = {}
    payload.type = 'customLabel'

    if (fullName){ payload.fullName = fullName }
    else { this.handleMissingField('Full name'); return }

    if (role){ payload.role = role }
    else { this.handleMissingField('Role'); return }

    if (username){ payload.username = username }
    else { this.handleMissingField('Username'); return }

    if (email){ payload.email = email }
    else { this.handleMissingField('Email'); return }

    if (phone){ payload.phone = phone }
    else { this.handleMissingField('Phone'); return }

    if (organizationName){ payload.organizationName = organizationName }
    else { this.handleMissingField('Organization'); return }

    if (timezone){ payload.timezone = timezone }
    else { this.handleMissingField('Timezone'); return }

    if(selectedSubscriptionId <= 0) {
      this.handleMissingFieldWithErr('Please select a subscription plan'); return
    }

    subscriptionApi.create(payload, subscription => {
      if (!subscription) return
    
      payloadPendingPayment.subId = subscription.id
      subscriptionApi.paymentIntent(payloadPendingPayment, pendingPayment => {
        if (!pendingPayment) return
        this.setState({
          fullName: fullName,
          role: role,
          username: username,
          email: email,
          phone: phone,
          organizationName: organizationName,
          timezone: timezone,
          address: address,
          city: city,
          state: state,
          zip: zip,
          amountSelected: amountSelected,
          selectedSubscriptionId : selectedSubscriptionId,
          subscriptionStepOn: false,
          paymentStepOn: true,
          clientSecret: pendingPayment.client_secret,
          subId: subscription.id,
          ephemeralKey: pendingPayment.customer_secret,
          customer: pendingPayment.customer_id,
          isLoading: false
        })
      }) 
    },error => { 
      this.handleCreateError(error)
    })

    
     
    
  }

  render () {
    const { stripe, clientSecret, ephemeralKey, customer } = this.state;

    const options = {
      // passing the client secret obtained from the server
      clientSecret: clientSecret,
      customerSessionClientSecret: ephemeralKey,
      //customer: customer
    };

    const options2 = {
      customerSessionClientSecret: ephemeralKey,
      ephemeralKey: ephemeralKey
    }

    if(this.state.subscriptionStepOn) {
      return (
        <Page size='full'>
          {this.state.isLoading && <LoadingOverlay />}
          <SubscribeForm type="regular" onSubscribe={ this.onSubscribe } />
        </Page>
      );
    } else if(this.state.paymentStepOn) {
      return (
        <Page size='full'>
          <Elements stripe={stripe} options={options}>  
            <InjectedCheckoutForm />
          </Elements>
        </Page>
      );
    }
   
  }
}
